import { render, staticRenderFns, recyclableRender, components } from "./sorting.vue?vue&type=template&id=2412a810&scoped=true&"
var renderjs
import script from "./sorting.vue?vue&type=script&lang=js&"
export * from "./sorting.vue?vue&type=script&lang=js&"
import style0 from "./sorting.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sorting.vue?vue&type=style&index=1&id=2412a810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412a810",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/sorting/sorting.vue"
export default component.exports